import React from 'react';
import isEmpty from 'lodash/isEmpty';
import ReactDOM from 'react-dom';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import * as CorePopups from 'core/modules/Popups';
import { useHandleBonusButtonPopup }
  from 'core/modules/BonusButton/components/BonusButtonPopup/hooks/useHandleBonusButtonPopup';
import { usePopup } from '../PopupProvider';

function PopupRoot() {
  const { popup, openPopup, closePopup } = usePopup();

  useHandleBonusButtonPopup();

  if (isEmpty(popup)) {
    return null;
  }

  const Component = CorePopups[popup.name];

  if (!Component) {
    return null;
  }

  return (
    ReactDOM.createPortal(
      <Component popup={popup} openPopup={openPopup} closePopup={closePopup} />,
      document.getElementById('app'),
    )
  );
}

export default (props) => <ComponentErrorBoundary><PopupRoot {...props} /></ComponentErrorBoundary>;
